// ─────────────────────────────────────────────────────────────────
// Glass-i — Production Department Master API client (Stage 6B.8A-3K.3).
//
// Thin axios wrappers around /api/erp/masters/production-departments/*.
// Used by ProductionDepartmentsPage AND by ProcessMasterPage (to load
// the active department lookup with fallback).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/production-departments';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const productionDepartmentsApi = {
  list:    (params = {}) => client.get(BASE, { params }).then(unwrap),
  tree:    (params = {}) => client.get(`${BASE}/tree`, { params }).then(unwrap),
  lookups: (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  // Stage 6B.8A-3K.6 — execution-flow view (route-stage rows only,
  // sorted by execution_order).
  executionFlow: (params = {}) =>
    client.get(`${BASE}/execution-flow`, { params }).then(unwrap),
  get:     (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:  (payload)     => client.post(BASE, payload).then(unwrap),
  // WO-2C — update/remove forward an optional Approval-MFA challenge id.
  // The PUT gate reads it from the body; DELETE (no body) sends the header.
  update:  (id, payload, challengeId) => client.put(
    `${BASE}/${encodeURIComponent(id)}`,
    challengeId ? { ...payload, approvalMfaChallengeId: challengeId } : payload
  ).then(unwrap),
  remove:  (id, challengeId) => client.delete(
    `${BASE}/${encodeURIComponent(id)}`,
    challengeId ? { headers: { 'x-approval-mfa-challenge-id': challengeId } } : undefined
  ).then(unwrap),
  // WO-2C — read-only pre-check before disabling/archiving a department.
  removalImpact: (id) =>
    client.get(`${BASE}/${encodeURIComponent(id)}/removal-impact`).then(unwrap),
  reorder: (payload)     => client.post(`${BASE}/reorder`, payload).then(unwrap)
};

// Convenience helpers — silent failure returns null so callers can
// fall back to a hardcoded list (e.g. Process Master) without
// crashing the page.
export async function loadDepartmentLookupsSafe() {
  try {
    return await productionDepartmentsApi.lookups();
  } catch (_e) {
    return null;
  }
}

export default productionDepartmentsApi;
